module.exports = __webpack_public_path__ + "static/media/badminton.871358a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/badminton.svg
// module id = 358
// module chunks = 7